import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const ReceivedDate = {
  id: 'receivedDate',
  displayName: <FormattedMessage {...messages.receivedDate} />,
  type: OptionFormTypes.TYPE_DATE_COMPARISON_DEPRECATED,
  filterValue: 'receivedDateTime',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_DATE_COMPARISON_DEPRECATED, criteriaInformations);
  },
};
